"use client";

import {
  createContext,
  useState,
  useCallback,
  useEffect,
  ReactNode,
} from "react";
import ToastAlert from "@/components/ui/ToastAlert";
import { popToast, Toast } from "@/utils/toast";

interface ToastContextValue {
  showToast: (toast: Toast) => void;
}

export const ToastContext = createContext<ToastContextValue | undefined>(
  undefined
);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<Toast | null>(null);

  const showToast = useCallback((toast: Toast) => setToast(toast), []);

  // 리로드 후 sessionStorage에 저장된 토스트가 있으면 꺼내서 즉시 띄우기
  useEffect(() => {
    const t = popToast();
    if (t) setToast({ message: t.message, type: t.type, duration: t.duration });
  }, []);

  useEffect(() => {
    if (!toast) return;
    const ms = toast.duration ?? 3000; // 지속시간 적용
    const timer = setTimeout(() => setToast(null), ms);
    return () => clearTimeout(timer);
  }, [toast]);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast && <ToastAlert type={toast.type} message={toast.message} />}
    </ToastContext.Provider>
  );
}
